import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthConfig } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authConfig: AuthConfig = {
    issuer: 'http://localhost',
    redirectUri: 'http://localhost:4200/callback',  
    clientId: '9d2203f9-d8df-4546-8eae-21fa4441b88e', 
    responseType: 'code',
    loginUrl: 'http://localhost/oauth/authorize',
    tokenEndpoint: 'http://localhost/oauth/token',
    userinfoEndpoint: 'http://localhost/office/api/me',
    requireHttps: false,
    scope: '',  
    showDebugInformation: true,
  };

  private isLoggedIn = new Observable((observer) => {
    observer.next(false);
  });

  constructor(private oauthService: OAuthService) {
    this.authConfig.issuer = environment.issuer;
    this.authConfig.redirectUri = environment.redirect_uri;
    this.authConfig.clientId = environment.client_id;
    this.authConfig.loginUrl = environment.login_url;
    this.authConfig.tokenEndpoint = environment.token_endpoint;
    this.authConfig.userinfoEndpoint = environment.userinfo_endpoint;

    this.configure();
  }

  private configure() {
    this.oauthService.configure(this.authConfig);
    this.oauthService.setupAutomaticSilentRefresh();
  }

  public login() {
    this.oauthService.configure(this.authConfig);
    this.oauthService.initCodeFlow();
  }

  public logout() {
    this.oauthService.logOut();
  }

  public getClientId() {
    return this.authConfig.clientId;
  }

  public getIssuer() {
    return this.authConfig.issuer;
  }

  retrieveToken () {
    this.oauthService.configure(this.authConfig);
    return this.oauthService.tryLogin().then(() => {
      if (this.oauthService.hasValidAccessToken()) {
        //logged in
      } else {
        throw {
          code: 'NO_VALID_TOKEN',
          message: 'Login failed: No valid access token'
        };
      }
    }).catch(err => {
      if (err.code) {
        throw err;
      } else {
        throw {
          code: 'ERROR_DURING_PROCESS',
          message: 'Error during login process:' + err
        };
      }
    });
  }

  getProfile() {
    const profile = this.oauthService.getIdentityClaims();
    return profile;
  }

  getToken() {
    return this.oauthService.getAccessToken();
  }
}